/**
 * Convert string to Pascal Case with proper spacing
 * Examples:
 * - "name" → "Name"
 * - "department_name" → "Department Name"
 * - "userId" → "User Id"
 * - "created_on" → "Created On"
 */
export function toPascalCase(str: string): string {
  if (!str) return "";
  return str
    // Split on underscores
    .split("_")
    // Split on camelCase transitions (e.g., "userId" -> "user Id")
    .flatMap((word) =>
      word.replace(/([a-z])([A-Z])/g, "$1 $2").split(" ")
    )
    // Filter empty strings and capitalize each word
    .filter((w) => w.length > 0)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}
